RivalIQ.apps.Admin.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const Company = apps.Company = window.createMarionetteApp();
    Company.name = 'Company';

    Company.addRegions({
        handleDiscoveryModal: '#companyHandleDiscoveryModal',
        socialHandlesModal: '#adminCompanySocialHandlesModal',
        companyPrimaryHandleDeleteModal: '#adminCompanyPrimaryHandleDeleteModal',
        companyDeleteModal: '#adminCompanyDeleteModal'
    });
});
